import * as React from 'react'
import styled from 'styled-components'

import Modal, { DefaultCloseButton } from '../../ui/Modal/Modal'
import media from '../../../services/generateMediaQueries'
import Loader from '../../../assets/img/loader.gif'
import Icon from '../../ui/Icon/Icon'

const StyledModal = styled(Modal)`
  width: 800px;
  min-width: 800px;

  ${media.lessThan('small')`
    min-width: unset;
    width: 100%;
    border-radius: 0;
  `}
`
const StyledIFrame = styled.iframe.attrs({ className: 'scrollbar' })`
  border: 0;
  width: 100%;
  display: block;
  min-height: calc(100vh - 6em);

  ${media.lessThan('small')`
    height: 100vh;
    width: 100vw;
  `}
`
const IFrameWrapper = styled.div`
  position: relative;
  background: url(${Loader}) center center no-repeat;
  background-size: 64px;
`
const CloseButton = styled(DefaultCloseButton)`
  background: rgba(255, 255, 255, 1);
`

const SpinAndWinModal = ({ show, zIndex, onClose, url }) => {
  return (
    <StyledModal
      id="spinAndWinModal"
      zIndex={zIndex}
      show={show}
      hasCloseButton={false}
      handleClose={e => {
        e.stopPropagation()
        onClose(e)
      }}
    >
      <IFrameWrapper>
        <CloseButton
          zIndex={zIndex}
          onClick={e => {
            e.stopPropagation()
            onClose(e)
          }}
        >
          <Icon name="x" />
        </CloseButton>
        <StyledIFrame src={url} seamless={true} title="Spin and Win" />
      </IFrameWrapper>
    </StyledModal>
  )
}

SpinAndWinModal.defaultProps = {
  show: false,
  onClose: () => {},
  url: '',
}

export default SpinAndWinModal
